/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import PlaylistPlayRoundedIcon from "@mui/icons-material/PlaylistPlayRounded";
import SquareRoundedIcon from "@mui/icons-material/SquareRounded";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import CircleRoundedIcon from "@mui/icons-material/CircleRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import {
  // RecordWebcam,
  useRecordWebcam,
  CAMERA_STATUS,
} from "react-record-webcam";
import {
  Box,
  FormControlLabel,
  Switch,
  Typography,
  styled,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useAudioRecorder } from "react-audio-voice-recorder";

import {
  setCustomModal,
  setModalType,
} from "../../../redux/features/settingSlice";
import CustomCircleButton from "../CustomCircleButton";
import CustomInput from "../CustomInput";
import mic from "../../../media/svg/mic.svg";
import video from "../../../media/svg/video.svg";
import RecorderTimeline from "./RecorderTimeline";
import UseStopWatch from "../../../hooks/UseStopWatch";

const OPTIONS = {
  filename: "test-filename",
  fileType: "mp4",
  width: 1080,
  height: 1920,
  // aspectRatio: 16 / 9,
  recordingLength: 300,
};

const ActionRecorderBtn = () => {
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [videoOnlyRecorder, setVideoOnlyRecorder] = useState(false);
  const [voiceRecording, setVoiceRecording] = useState(true);
  const [time, setTime] = useState(0);
  const [handleStart, handleStop] = UseStopWatch(setTime);
  const maxTime = 300;

  const VoiceSwitch = styled(Switch)(({ theme }) => ({
    "&.MuiSwitch-root": {
      width: 54,
      height: 34,
      padding: 0,
      borderRadius: 16,
      border: `2px solid ${theme.palette.black.main}`,
      overflow: "unset",
      "& .MuiSwitch-track": {
        borderRadius: 16,
        opacity: `${1}!IMPORTANT`,
        backgroundColor: `${
          videoOnlyRecorder
            ? theme.palette.primary.main
            : theme.palette.white.main
        } !IMPORTANT`,
      },
      "& .Mui-voiceOnlyed  .MuiSwitch-track": {
        borderRadius: 16,
        opacity: `${1}!IMPORTANT`,
        backgroundColor: `${
          videoOnlyRecorder
            ? theme.palette.primary.main
            : theme.palette.white.main
        } !IMPORTANT`,
      },
      "& .MuiButtonBase-root": {
        padding: 0,
      },

      "& .MuiSwitch-thumb": {
        boxShadow: `0px 0px 0px 2px ${theme.palette.black.main}`,
        width: 30,
        height: 30,
        margin: 2,
        position: "absolute",
        top: -2,
        left: -2,
        backgroundPosition: "center",
        backgroundImage: `url(${videoOnlyRecorder ? video : mic})`,
        backgroundSize: "21px 21px",
        backgroundRepeat: "no-repeat",
        opacity: `${1}!IMPORTANT`,
        zIndex: 12,
      },
    },
  }));
  const recordWebcam = useRecordWebcam(OPTIONS);
  const {
    startRecording,
    stopRecording,
    togglePauseResume,
    recordingBlob,
    isRecording,
    isPaused,
    recordingTime,
    // mediaRecorder,
  } = useAudioRecorder();
  // const addAudioElement = (blob) => {
  //   const url = URL.createObjectURL(blob);
  //   const audio = document.createElement("audio");
  //   audio.src = url;
  //   audio.controls = true;
  //   document.body.appendChild(audio);
  // };
  // const getRecordingFileHooks = async () => {
  //   const blob = await recordWebcam.getRecording();
  //   console.log({ blob });
  // };

  const handlePlayListModal = () => {
    dispatch(setCustomModal(true));
    dispatch(setModalType("PlayList"));
  };
  useEffect(() => {
    if (videoOnlyRecorder) {
      recordWebcam.open();
    } else {
      recordWebcam.close();
      handleStop();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoOnlyRecorder]);

  const handleRecord = () => {
    if (videoOnlyRecorder) {
      if (recordWebcam.status === CAMERA_STATUS.RECORDING) {
        recordWebcam.stop();
        recordWebcam.close();
        handleStop();
      } else {
        recordWebcam.start();
        handleStart();
      }
    } else {
      if (isRecording) {
        stopRecording();
      } else {
        startRecording();
        setVoiceRecording(true);
      }
    }
  };

  const handlePauseRecorder = () => {
    if (videoOnlyRecorder) {
      if (recordWebcam.status === CAMERA_STATUS.PREVIEW) {
        recordWebcam.retake();
      }
    } else {
      if (isRecording) {
        togglePauseResume();
      } else {
        setVoiceRecording(false);
      }
    }
  };

  const PauseComponent = () => {
    if (videoOnlyRecorder) {
      if (recordWebcam.status === CAMERA_STATUS.PREVIEW) {
        return <DeleteOutlineRoundedIcon sx={{ fontSize: "28px" }} />;
      } else {
        return <PauseRoundedIcon sx={{ fontSize: "28px" }} />;
      }
    } else {
      if (recordingBlob && !isRecording && voiceRecording) {
        return <DeleteOutlineRoundedIcon sx={{ fontSize: "28px" }} />;
      } else {
        if (isPaused) {
          return <PlayArrowRoundedIcon sx={{ fontSize: "28px" }} />;
        } else {
          return <PauseRoundedIcon sx={{ fontSize: "28px" }} />;
        }
      }
    }
  };

  const handleVideoOnly = () => {
    setVideoOnlyRecorder(!videoOnlyRecorder);
  };

  useEffect(() => {
    if (recordingTime >= maxTime) {
      stopRecording();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordingTime]);

  return (
    <>
      {/* <VideoRecorder
        onTurnOnCamera={() => alert(123)}
        // isFlipped={false}
        style={{ position: "fixed", width: "100%", height: "100%" }}
        
        onRecordingComplete={(videoBlob) => {
          // Do something with the video...
          console.log("videoBlob", videoBlob);
        }}
      /> */}
      {/* <Box sx={{ position: "fixed", width: "100%", height: "100%", top: 70 }}>
        {" "}
        <AudioRecorder
          // onRecordingComplete={(blob) => addAudioElement(blob)}
          // recorderControls={recorderControls}
          showVisualizer
        />
      </Box> */}

      <Box
        sx={{
          direction: "rtl",
          display: "flex",
          alignItems: "center",
          width: "55px",
          position: "fixed",
          right: "16px",
          top: "74px",
          zIndex: 5,
        }}
      >
        <FormControlLabel
          onChange={handleVideoOnly}
          sx={{
            "& .MuiTypography-root": {
              color: "white.main",
              fontSize: 12,
              fontWeight: 600,
              mr: "8px",
            },
            "&.MuiFormControlLabel-root": { mr: 0 },
          }}
          disabled={
            (videoOnlyRecorder &&
              recordWebcam.status === CAMERA_STATUS.RECORDING) ||
            (!videoOnlyRecorder && isRecording)
          }
          control={<VoiceSwitch color='white' checked={videoOnlyRecorder} />}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
          position: "fixed",
          bottom: "80px",
          alignItems: "center",
          right: 0,
          left: 0,
          zIndex: 3,
        }}
      >
        <Box sx={{ position: "absolute", width: "92%", bottom: "70px" }}>
          {(videoOnlyRecorder &&
            recordWebcam.status === CAMERA_STATUS.PREVIEW) ||
          (!videoOnlyRecorder &&
            recordingBlob &&
            !isRecording &&
            voiceRecording) ? (
            <CustomInput
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              label='Post title'
              bgColor='white.main'
              minLength={3}
              maxLength={100}
              req
            />
          ) : null}
        </Box>

        <Box sx={{ ml: "30px" }}>
          <CustomCircleButton
            onClick={handlePauseRecorder}
            width={"48px"}
            height={"48px"}
            bgColor='white.main'
            color='black.main'
            bShadow='none'
            border='2px solid'
            hoverBgColor='white.main'
            hoverColor='black.main'
            hoverBorder={`2px solid`}
            activeBgColor='black.main'
            activeColor='white.main'
            disabledColor='white.main'
            disabled={
              (videoOnlyRecorder &&
                recordWebcam.status !== CAMERA_STATUS.PREVIEW) ||
              (!videoOnlyRecorder && !isRecording && !voiceRecording)
            }
          >
            <PauseComponent />
          </CustomCircleButton>
        </Box>
        <CustomCircleButton
          onClick={handleRecord}
          width={"64px"}
          height={"64px"}
          bgColor='danger.main'
          color='white.main'
          bShadow='none'
          border='2px solid'
          hoverBgColor='danger.main'
          hoverColor='white.main'
          hoverBorder={`2px solid`}
          activeBgColor='white.main'
          activeColor='danger.main'
          disabledColor='white.main'
          disabled={
            (videoOnlyRecorder &&
              (recordWebcam.status === CAMERA_STATUS.PREVIEW ||
                recordWebcam.status === CAMERA_STATUS.ERROR)) ||
            (!videoOnlyRecorder &&
              !isRecording &&
              recordingBlob &&
              voiceRecording)
          }
        >
          {(videoOnlyRecorder &&
            recordWebcam.status === CAMERA_STATUS.RECORDING) ||
          (!videoOnlyRecorder && isRecording) ? (
            <SquareRoundedIcon sx={{ fontSize: "32px" }} />
          ) : (
            <CircleRoundedIcon sx={{ fontSize: "32px" }} />
          )}
        </CustomCircleButton>
        <Box sx={{ mr: "30px" }}>
          <CustomCircleButton
            onClick={handlePlayListModal}
            width={"48px"}
            height={"48px"}
            bgColor='white.main'
            color='black.main'
            bShadow='none'
            border='2px solid'
            hoverBgColor='white.main'
            hoverColor='black.main'
            hoverBorder={`2px solid`}
            activeBgColor='black.main'
            activeColor='white.main'
          >
            <PlaylistPlayRoundedIcon sx={{ fontSize: "28px", ml: "3px" }} />
          </CustomCircleButton>
        </Box>
      </Box>
      {/* <div>
        <Button
          disabled={
            recordWebcam.status === CAMERA_STATUS.OPEN ||
            recordWebcam.status === CAMERA_STATUS.RECORDING ||
            recordWebcam.status === CAMERA_STATUS.PREVIEW
          }
          onClick={recordWebcam.open}
        >
          Open camera
        </Button>
        <Button
          disabled={
            recordWebcam.status === CAMERA_STATUS.CLOSED ||
            recordWebcam.status === CAMERA_STATUS.PREVIEW
          }
          onClick={recordWebcam.close}
        >
          Close camera
        </Button>
        <Button
          disabled={
            recordWebcam.status === CAMERA_STATUS.CLOSED ||
            recordWebcam.status === CAMERA_STATUS.RECORDING ||
            recordWebcam.status === CAMERA_STATUS.PREVIEW
          }
          onClick={recordWebcam.start}
        >
          Start recording
        </Button>
        <Button
          disabled={recordWebcam.status !== CAMERA_STATUS.RECORDING}
          onClick={recordWebcam.stop}
        >
          Stop recording
        </Button>
        <Button
          disabled={recordWebcam.status !== CAMERA_STATUS.PREVIEW}
          onClick={recordWebcam.retake}
        >
          Retake
        </Button>
        <Button
          disabled={recordWebcam.status !== CAMERA_STATUS.PREVIEW}
          onClick={recordWebcam.download}
        >
          Download
        </Button>
        <Button
          disabled={recordWebcam.status !== CAMERA_STATUS.PREVIEW}
          onClick={getRecordingFileHooks}
        >
          Get recording
        </Button>
      </div> */}
      {recordWebcam.status === "ERROR" && videoOnlyRecorder && (
        <Typography
          sx={{
            fontSize: "20px",
            color: "white.main",
            top: "50%",
            position: "fixed",
            width: "100%",
            textAlign: "center",
            px: "16px",
          }}
        >
          This browser is uncapable of recording video or you do not have a
          camera
        </Typography>
      )}
      {videoOnlyRecorder ? (
        <>
          <video
            ref={recordWebcam.webcamRef}
            style={{
              position: "fixed",
              // width: "100%",
              height: "100%",
              bottom: 0,
              display: `${
                recordWebcam.status === CAMERA_STATUS.OPEN ||
                recordWebcam.status === CAMERA_STATUS.RECORDING
                  ? "block"
                  : "none"
              }`,
            }}
            autoPlay
            muted
          />
          <video
            ref={recordWebcam.previewRef}
            // src='https://s3.ir-tbz-sh1.arvanstorage.ir/azadapp-bucket/topics/files/95657986a31d48018319c78cc87ad932.mp4?AWSAccessKeyId=9cef4966-2d83-4253-a12a-ad79daea268a&Signature=08NIRCW5zN6kvNCOLJ9FiaHdjHY%3D&Expires=1689654232'
            style={{
              position: "fixed",
              width: "100%",
              height: "100%",
              bottom: 0,
              display: `${
                recordWebcam.status === CAMERA_STATUS.PREVIEW ? "block" : "none"
              }`,
            }}
            controls
          />
          {recordWebcam.status !== CAMERA_STATUS.PREVIEW && (
            <Box
              sx={{
                position: "fixed",
                bottom: "2px",
                width: "90%",
                left: 26,
                right: 26,
              }}
            >
              <RecorderTimeline time={time} maxTime={maxTime} />
            </Box>
          )}
        </>
      ) : (
        <>
          {recordingBlob && !isRecording && voiceRecording ? (
            <audio
              type='audio/webm'
              style={{
                position: "fixed",
                width: "92.5%",
                height: "40px",
                bottom: 22,
                right: 16,
                left: 16,
              }}
              controls
              src={URL.createObjectURL(recordingBlob)}
            />
          ) : (
            <Box
              sx={{
                position: "fixed",
                bottom: "2px",
                width: "90%",
                left: 26,
                right: 26,
              }}
            >
              <RecorderTimeline time={recordingTime} maxTime={maxTime} />
            </Box>
          )}
        </>
      )}

      {/* {!videoOnlyRecorder && !voiceRecording && (
        
      )} */}
      {/* <Button
        style={{
          position: "fixed",
          width: "100%",
          height: "100%",

       
        }}
        // disabled={recordWebcam.status !== CAMERA_STATUS.PREVIEW}
        onClick={getRecordingFileHooks}
      >
        Get recording
      </Button> */}
    </>
  );
};
export default ActionRecorderBtn;
